// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import slideshow from './js/widgets/slideshow.js';
import autoEvent from './js/widgets/autoEvent.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import gallery from './js/widgets/gallery.js';
import staticSponsors from './js/widgets/staticSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    slideshow();
    autoEvent();
    cardWidget('cardWidgetFirst', cardWidgetFirstOpts, 2);
    cardWidget('cardWidgetSecond', cardWidgetSecondOpts, 4);
    seoWidget();
    hotButtons();
    gallery();
    staticSponsors();
    scrollerSponsors();
  }
});
